import NawyERealtyLogo from "@/assets/icons/nawy-erealty-logo";
import { LeadLocationAction, LeadSidebarTabs } from "@/modules/lead-page/types";
import { Building2, List, MapPin, MessageSquareText } from "lucide-react";
import { LeadListingsLabel } from "../types";
import { PermissionLevel, PermissionsEnum } from "@/modules/common/types";
import { FinishingTypes } from "@/modules/sales/dtos";
import ERealtyIcon from "@/assets/icons/lead-page/ereality-icon";

export const leadListingsLabels: LeadListingsLabel[] = [
  { key: "uid", label: "Listing id" },
  { key: "ownerName", label: "Owner Name" },
  { key: "propertyType", label: "Property Type" },
  { key: "bedrooms", label: "Bedrooms" },
  { key: "unitArea", label: "Unit Area" },
  { key: "actualPrice", label: "Unit Price" },
  { key: "maintenance", label: "Maintenance" },
  { key: "lastInstallmentDate", label: "Last Installment Date" },
  { key: "askingPrice", label: "Unit Asking Price" },
  { key: "readyBy", label: "Delivery Date" },
  { key: "listingAgentEmail", label: "Assigned Admin" },
  { key: "unitNumber", label: "Unit Number" },
  { key: "unitAddress", label: "Unit Address" },
  { key: "floorNumber", label: "Floor Number" },
  { key: "bathrooms", label: "Bathrooms" },
  { key: "gardenArea", label: "Garden Area" },
  { key: "remainingInstallments", label: "Remaining Installments" },
  { key: "downpayment", label: "Down Payment" },
  { key: "finishing", label: "Finishing" },
  { key: "status", label: "Status" },
  { key: "phase", label: "Phase" },
  { key: "updatedAt", label: "Updated At" },
];

export const leadSidebarTabs: LeadSidebarTabs[] = [
  {
    label: "Location",
    permissions: [{ name: PermissionsEnum.ALL, level: PermissionLevel.ALL }],
  },
  {
    label: "Campaign",
    permissions: [{ name: PermissionsEnum.ALL, level: PermissionLevel.ALL }],
  },
  {
    label: "Listings",
    permissions: [{ name: PermissionsEnum.ALL, level: PermissionLevel.ALL }],
  },
  {
    label: "Sales",
    permissions: [
      { name: PermissionsEnum.JOURNEY_SALES, level: PermissionLevel.READ },
    ],
  },

  {
    label: "Collection",
    permissions: [
      { name: PermissionsEnum.JOURNEY_COLLECTION, level: PermissionLevel.READ },
    ],
  },
];

export const activityDetailsTabs = [
  {
    icon: MessageSquareText,
    label: "Activity",
    value: 0,
  },
  { icon: List, label: "Details", value: 1 },
];

export const leadLocationActions: LeadLocationAction[] = [
  {
    icon: MapPin,
    label: "Location",
    customStyles: {},
  },
  {
    icon: Building2,
    label: "Inventory",
    customStyles: {},
  },
  {
    icon: NawyERealtyLogo,
    label: "E-Realty",
    customStyles: {
      "&:disabled": {
        background: "#008F7A",
        color: "white",
        opacity: 0.3,
      },
    },
  },
];

export const leadLocationActionV2: LeadLocationAction[] = [
  {
    icon: ERealtyIcon,
    label: "E-Realty",
    customStyles: {
      "&:disabled": {
        background: "#008F7A",
        color: "white",
        opacity: 0.3,
      },
    },
  },
];

export const finishingOptions = [
  { value: FinishingTypes.Finished, label: "Finished" },
  { value: FinishingTypes.SemiFinished, label: "Semi-Finished" },
  { value: FinishingTypes.Unfinished, label: "Unfinished" },
];

export enum LeadTypeOption {
  TypeCorrection = 1,
  ReassignNoReferral = 2,
  ReassignReferral = 3,
}
export const AssignmentMethods = {
  AUTO_ASSIGN: "Auto Assign (random)",
  SELECT_USER: "Select a user",
} as const;

export const AddLeadType = {
  PERSONAL: "Personal Lead",
  REFERRAL: "Referral Lead",
} as const;

export type AddLeadType = (typeof AddLeadType)[keyof typeof AddLeadType];

export type LeadTypeRadioAssignmentType =
  (typeof AssignmentMethods)[keyof typeof AssignmentMethods];

export const LeadReferralOptions = {
  CHANGE_CURRENT_LEAD_AND_REFER:
    "Refer lead to another team (commission applies)",
  KEEP_CURRENT_LEAD_AND_REFER_NEW_LEAD:
    "Refer lead to another team and keep current lead(commission applies)",
} as const;

export type LeadReferralOptionsType =
  (typeof LeadReferralOptions)[keyof typeof LeadReferralOptions];

export const INVALID_CUSTOMER_REASONS = {
  CONTACTED_US_BY_MISTAKE: "Contacted Us By Mistake",
  RANDOM_QUESTION: "Random Question",
  INVALID_COUNTRIES: "Invalid Countries",
  OUTSIDE_OF_NETWORK: "Outside of Network",
  PARTNERSHIP_SPONSORSHIP: "Partnership/Sponsorship",
  CAREERS: "Careers",
  ESCALATION: "Escalation",
  TEST: "Test",
};
